import { useQueryPlans, useQueryAccountPlan, useQueryAccountNotifications, } from '../../../hooks';
import { useQueryAccount, useQuerySession, useQueryAccountUsage, useQueryEntitlements, } from '../../../../universal-nav/hooks';
import { getNextPlan } from './getNextPlan';
export const useAlertBannerData = () => {
    var _a;
    const { data: sessionData, isLoading: isLoadingSessionData, isError: isErrorSessionData, } = useQuerySession();
    const { data: accountData, isLoading: isLoadingAccountData, isError: isErrorAccountData, } = useQueryAccount({ currentAccountId: sessionData === null || sessionData === void 0 ? void 0 : sessionData.currentAccountId });
    const { data: planGroupsData, isLoading: isLoadingPlans, isError: isErrorPlans, } = useQueryPlans(sessionData === null || sessionData === void 0 ? void 0 : sessionData.currentAccountId);
    const { data: accountUsageData, isLoading: isLoadingAccountUsageData, isError: isErrorAccountUsageData, } = useQueryAccountUsage(sessionData === null || sessionData === void 0 ? void 0 : sessionData.currentAccountId);
    const { data: accountPlanData, isLoading: isLoadingAccountPlanData, isError: isErrorAccountPlanData, } = useQueryAccountPlan(sessionData === null || sessionData === void 0 ? void 0 : sessionData.currentAccountId, (_a = accountData === null || accountData === void 0 ? void 0 : accountData.plan) === null || _a === void 0 ? void 0 : _a.id);
    const { data: entitlementsData, isLoading: isLoadingEntitlementsData, isError: isErrorEntitlementsData, } = useQueryEntitlements(sessionData === null || sessionData === void 0 ? void 0 : sessionData.currentAccountId);
    const { data: accountNotificationsData, isLoading: isLoadingAccountNotificationsData, isError: isErrorAccountNotificationsData, } = useQueryAccountNotifications(sessionData === null || sessionData === void 0 ? void 0 : sessionData.currentAccountId, [
        'workspace',
    ]);
    let currentPlan;
    for (const group of Array.from(planGroupsData || [])) {
        const matchingPlan = group.plans.find((plan) => plan.id === (accountData === null || accountData === void 0 ? void 0 : accountData.plan.id));
        if (matchingPlan) {
            currentPlan = matchingPlan;
            break;
        }
    }
    const isLoading = isLoadingAccountData ||
        isLoadingSessionData ||
        isLoadingPlans ||
        isLoadingAccountUsageData ||
        isLoadingAccountPlanData ||
        isLoadingEntitlementsData ||
        isLoadingAccountNotificationsData;
    const isError = isErrorAccountData ||
        isErrorSessionData ||
        isErrorPlans ||
        isErrorAccountUsageData ||
        isErrorAccountPlanData ||
        isErrorEntitlementsData ||
        isErrorAccountNotificationsData;
    const isAllDataAvailable = !!sessionData &&
        !!accountData &&
        !!planGroupsData &&
        !!accountUsageData &&
        !!currentPlan &&
        !!accountPlanData &&
        !!entitlementsData &&
        !!accountNotificationsData;
    if (isLoading) {
        return {
            isError: false,
            isLoading: true,
            data: undefined,
        };
    }
    if (isError) {
        return {
            isError: true,
            isLoading: false,
            data: undefined,
        };
    }
    if (!isAllDataAvailable) {
        return {
            isError: false,
            isLoading: false,
            data: undefined,
        };
    }
    const currentPlanSpecifics = {
        actions_used: accountUsageData.tasks.total,
        interval: accountPlanData.interval,
        plan_type: accountPlanData.planType,
        total_actions: accountPlanData.actions,
        included_tasks_per_month: accountPlanData.includedTasksPerMonth,
    };
    const alertBannerData = {
        isAuthenticated: sessionData.isLoggedIn,
        currentUser: sessionData,
        currentAccount: {
            id: accountData.id,
            currency: accountData.currency,
            currentUserRole: sessionData.currentUserRole,
            firstKnownUpgradeDate: accountData.firstKnownUpgradeDate,
            isUnlimited: accountData.isUnlimited,
            hasOverdueInvoice: accountData.hasOverdueInvoice,
            periodStartDate: accountUsageData.periodStart,
            periodEndDate: accountUsageData.periodEnd,
            isTrialing: accountData.isTrialing,
            trialEndDate: accountData.trialEndDate,
            isTeamAccount: accountData.isTeamAccount,
            isTrialingTeams: accountData.isTrialingTeams,
            teamAccountEndDate: accountData.teamAccountEndDate,
            teamsTrialAutoUpgrade: accountData.teamsTrialAutoUpgrade,
            teamTrialEndDate: accountData.teamTrialEndDate,
            isCompanyAccount: accountData.isCompanyAccount,
            isTrialingCompanies: accountData.isTrialingCompanies,
            companiesTrialEndDate: accountData.companiesTrialEndDate,
            companiesTrialAutoUpgrade: accountData.companiesTrialAutoUpgrade,
            isEnterpriseAccount: accountData.isEnterpriseAccount,
            isTrialingEnterprise: accountData.isTrialingEnterprise,
            enterpriseTrialEndDate: accountData.enterpriseTrialEndDate,
            taskBufferOverride: accountData.taskBufferOverride,
            entitlements: entitlementsData,
            notifications: accountNotificationsData,
            plan: currentPlan,
            paysManually: accountData.paysManually,
            subscriptionRenewalDate: accountData.subscriptionRenewalDate,
        },
        possiblePlans: planGroupsData,
        nextPlan: getNextPlan(planGroupsData, currentPlanSpecifics, {
            nextPlanInterval: 'year',
        }),
        nextTeamPlan: getNextPlan(planGroupsData, currentPlanSpecifics, {
            nextPlanType: 'Team',
        }),
        nextCompanyPlan: getNextPlan(planGroupsData, currentPlanSpecifics, {
            nextPlanInterval: 'year',
            nextPlanType: 'Company',
        }),
    };
    return {
        data: alertBannerData,
        isLoading: false,
        isError: false,
    };
};
//# sourceMappingURL=useAlertBannerData.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
